<div class="container">
  <span class="top-link-row">
    <span (click)="navigateBack()" class="returnButton"
      >< License Batch Details</span
    >
  </span>

  <app-header [title]="detailsTitle"></app-header>

  <div class="status-card" *ngIf="loading">
    Loading license batch details...
  </div>

  <div class="content" *ngIf="!loading && batch">
    <section class="details-card">
      <div class="details-head">
        <div>
          <h2>{{ batchTitle }}</h2>
          <span class="batch-id">ID: {{ batchId }}</span>
        </div>
      </div>

      <div class="details-grid">
        <div class="details-item">
          <span class="label">Description</span>
          <span class="value">{{ batch.description || 'Not set' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Company</span>
          <span class="value">{{ companyLabel }}</span>
        </div>
        <div class="details-item">
          <span class="label">Licensed Product</span>
          <div
            class="chip-list"
            *ngIf="productLabel !== 'Not assigned'; else noProduct"
          >
            <span class="component-chip">{{ productLabel }}</span>
          </div>
          <ng-template #noProduct>
            <span class="value">Not assigned</span>
          </ng-template>
        </div>
        <div class="details-item">
          <span class="label">Scope</span>
          <div
            class="chip-list"
            *ngIf="scopeLabel !== 'Not assigned'; else noScope"
          >
            <span class="component-chip">{{ scopeLabel }}</span>
          </div>
          <ng-template #noScope>
            <span class="value">Not assigned</span>
          </ng-template>
        </div>
        <div class="details-item">
          <span class="label">Components</span>
          <div
            class="chip-list"
            *ngIf="componentNames.length > 0; else noComponents"
          >
            <span
              class="component-chip"
              *ngFor="let componentName of componentNames"
            >
              {{ componentName }}
            </span>
          </div>
          <ng-template #noComponents>
            <span class="value">Not set</span>
          </ng-template>
        </div>
        <div class="details-item">
          <span class="label">Valid From</span>
          <span class="value">{{ formatDate(batch.optionalValidAfter) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Valid To</span>
          <span class="value">{{ formatDate(batch.optionalValidBefore) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Batch Size</span>
          <span class="value">{{ batch.licenseBatchSize ?? 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Linked Devices</span>
          <span class="value">{{ linkedDevicesCount }}</span>
        </div>
        <div class="details-item">
          <span class="label">Available Company Devices</span>
          <span class="value">{{ availableDevicesCount }}</span>
        </div>
      </div>
    </section>

    <section class="table-section">
      <h3>Linked Devices</h3>
      <qs-table
        [data]="linkedDevicesRows"
        [columns]="linkedColumns"
        [isSearchEnabled]="isSearchEnabled"
        [isPaginatorEnabled]="isPaginatorEnabled"
        [paginatorConfig]="paginatorConfig"
      ></qs-table>
    </section>

    <section class="table-section">
      <h3>Company Devices (Unlinked)</h3>
      <div class="status-card inline-status" *ngIf="loadingCompanyDevices">
        Loading company devices...
      </div>
      <qs-table
        *ngIf="!loadingCompanyDevices"
        [data]="availableDevicesRows"
        [columns]="availableColumns"
        [isSearchEnabled]="isSearchEnabled"
        [isPaginatorEnabled]="isPaginatorEnabled"
        [paginatorConfig]="paginatorConfig"
      ></qs-table>
    </section>
  </div>
</div>
